import { css } from 'styled-components';

const sizes = {
  Mobile: 700,
  Desktop: 2600,
};
export default Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});
